import { motion } from "framer-motion";

const reveal = {
  hidden: { opacity: 0, y: 40 },
  show: { opacity: 1, y: 0, transition: { duration: 0.9, ease: [0.22, 1, 0.36, 1] } },
};

export default function Manifesto() {
  return (
    <section data-testid="manifesto-section" className="py-24 lg:py-36">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.p
          variants={reveal}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          className="mono-label text-[#E05638] mb-8"
        >
          01 // Vision
        </motion.p>

        <div className="grid lg:grid-cols-12 gap-12 items-end">
          <motion.h2
            variants={reveal}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-80px" }}
            className="lg:col-span-8 font-display font-bold tracking-tight leading-[1.08] text-3xl sm:text-4xl lg:text-5xl"
          >
            Basta costi astronomici una tantum. Benvenuto nell'era del{" "}
            <span className="text-[#E05638]">Web as a Service</span>.
          </motion.h2>
          <motion.p
            variants={reveal}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-80px" }}
            transition={{ delay: 0.15 }}
            className="lg:col-span-4 text-neutral-600 leading-relaxed text-base"
          >
            Realizziamo il tuo sito aziendale su misura e lo manteniamo aggiornato, sicuro e
            ottimizzato SEO ogni singolo mese. Un unico partner, un unico abbonamento.
          </motion.p>
        </div>

        <motion.div
          variants={reveal}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          className="mt-16 grid grid-cols-2 lg:grid-cols-4 gap-px bg-black/10 border border-black/10"
        >
          {[
            ["Su misura", "Design senza template"],
            ["1", "Unico referente per tutto"],
            ["Mensile", "Manutenzione e SEO incluse"],
            ["24h", "Tempo di risposta"],
          ].map(([v, l]) => (
            <div key={l} className="bg-[#FAF8F5] px-6 py-8 hover:bg-white transition-colors duration-300">
              <p className="font-display font-extrabold text-3xl sm:text-4xl">{v}</p>
              <p className="mono-label text-neutral-500 mt-3">{l}</p>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
